/**
 * @generated SignedSource<<bdb2b5ab249157988e273a4ca6b0c033>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type flagField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly " $fragmentType": "flagField_updateWorkItemFieldsActionRenderer";
};
export type flagField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: flagField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"flagField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "flagField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraFlagField"
};

(node as any).hash = "aa3dff23883f87fdc3d3e46f3e4613f0";

export default node;
